import React, { PureComponent } from "react";
import { InfoCircleOutlined, RightOutlined } from "@ant-design/icons";
import { Input, Select, Tooltip } from "antd";

const Option = Select.Option;

const RelationHoc = (ParentCom) => {
  return class extends PureComponent {
    constructor(props) {
      super(props);
      this.props = props;
      console.log(ParentCom);
    }

    // 自定义通用form（input关联）hoc
    parentItem(placeholder, paramName) {
      const hoc = this;
      const parentItem = class extends PureComponent {
        render() {
          const props = this.props;
          return (
            <Input
              type={"text"}
              placeholder={placeholder}
              disabled={props.disabled}
              {...props}
              onChange={(e) => {
                hoc.changeRelation.bind(hoc)(e, paramName);
              }}
            />
          );
        }
      };
      return parentItem;
    }

    childItem(placeholder) {
      const childItem = class extends PureComponent {
        render() {
          const props = this.props;
          return (
            <Input
              type={"text"}
              placeholder={placeholder}
              disabled={props.disabled}
              {...props}
            />
          );
        }
      };
      return childItem;
    }

    selectItem(placeholder, paramName) {
      const hoc = this;
      const parentItem = class extends PureComponent {
        render() {
          const props = this.props;
          return (
            <Select
              placeholder={placeholder}
              {...props}
              onChange={(e) => {
                hoc.changeSelect.bind(hoc)(e, paramName);
              }}
            >
              <Option key={0} value={"0"}>
                {"显示"}
              </Option>
              <Option key={1} value={"1"}>
                {"隐藏"}
              </Option>
            </Select>
          );
        }
      };
      return parentItem;
    }

    tipItem() {
      const parentItem = class extends PureComponent {
        render() {
          const props = this.props;
          return <Input type={"text"} {...props} />;
        }
      };
      const tipContent = (
        <div>
          <h3>标题1</h3>
          <p>鼠标移入则显示提示，移出消失，气泡浮层不承载复杂文本和操作。</p>
          <p className={"tip-r"}>
            <a href="">
              查看更多
              <RightOutlined />
            </a>
          </p>
          <h3>标题2</h3>
          <p>
            在开始之前，推荐先学习 React 和 ES2015，并正确安装和配置了 Node.js
            v8 或以上。 官方指南假设你已了解关于 HTML、CSS 和 JavaScript
            的中级知识，并且已经完全掌握了 React
            全家桶的正确开发方式。如果你刚开始学习前端或者 React，将 UI
            框架作为你的第一步可能不是最好的主意。
          </p>
        </div>
      );
      parentItem.rightbar = (
        <Tooltip
          placement="bottom"
          overlayClassName={"sc-tooltip"}
          title={tipContent}
          arrowPointAtCenter
        >
          <InfoCircleOutlined style={{ marginLeft: "10px" }} />
        </Tooltip>
      );
      return parentItem;
    }

    // select切换控制显示
    changeSelect(e, paramName) {
      const field = {};
      field[paramName] = e;
      // 操作formCore实例
      this.ctx.props.form.setFieldsValue(field);
      this.ctx.visibleChange.bind(this.ctx)(e, paramName);
    }

    // input监控实时变化
    changeRelation(e, paramName) {
      // 操作formCore实例
      this.ctx.props.form.setFieldsValue({ relationVal: e.target.value });
      this.ctx.props.form.setFieldsValue({ [paramName]: e.target.value });
    }

    render() {
      const items = [
        this.parentItem.bind(this),
        this.childItem.bind(this),
        this.selectItem.bind(this),
        this.tipItem.bind(this),
      ];
      // getInstance 获取子组件上下文
      return (
        <ParentCom
          {...this.props}
          relationInput={items}
          getInstance={(ctx) => {
            this.ctx = ctx;
          }}
        />
      );
    }
  };
};

export default RelationHoc;



// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo/forms/hoc/relationHoc.js